export const essentialCurrencyList = [
  {
    "key": "opt",
    "label": "OPT",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in Optimism Explorer",
    "explorerTx": "https://optimistic.etherscan.io/{TYPE}/{VALUE}",
    "explorerAddr": "https://optimistic.etherscan.io/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "Optimism"
  },
  {
    "key": "matic",
    "label": "MATIC",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in Polygon Explorer",
    "explorerTx": "https://polygonscan.com/{TYPE}/{VALUE}",
    "explorerAddr": "https://polygonscan.com/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "Polygon"
  },
  {
    "key": "arb",
    "label": "ARB",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in Arbitrum Explorer",
    "explorerTx": "https://arbiscan.io/{TYPE}/{VALUE}",
    "explorerAddr": "https://arbiscan.io/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "Arbitrum"
  },
  {
    "key": "bnb",
    "label": "BNB",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in BscScan",
    "explorerTx": "https://bscscan.com/{TYPE}/{VALUE}",
    "explorerAddr": "https://bscscan.com/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "BNB"
  },
  {
    "key": "base",
    "label": "BASE",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in Base Explorer",
    "explorerTx": "https://basescan.org/{TYPE}/{VALUE}",
    "explorerAddr": "https://basescan.org/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "Base"
  },
  {
    "key": "glmr",
    "label": "GLMR",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in Moonbeam Explorer",
    "explorerTx": "https://moonscan.io/{TYPE}/{VALUE}",
    "explorerAddr": "https://moonscan.io/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "Moonbeam"
  },
  {
    "key": "ada",
    "label": "ADA",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in Cardano Explorer",
    "explorerTx": "https://cardanoscan.io/{TYPE}/{VALUE}",
    "explorerAddr": "https://cardanoscan.io/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "Cardano"
  },
  {
    "key": "avax",
    "label": "AVAX",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in Avalanche Explorer",
    "explorerTx": "https://snowtrace.io/{TYPE}/{VALUE}",
    "explorerAddr": "https://snowtrace.io/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "Avalanche"
  },
  {
    "key": "sol",
    "label": "SOL",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in Solana Explorer",
    "explorerTx": "https://explorer.solana.com/{TYPE}/{VALUE}",
    "explorerAddr": "https://explorer.solana.com/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "Solana"
  },
  {
    "key": "ton",
    "label": "TON",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in TON Explorer",
    "explorerTx": "https://tonscan.org/{TYPE}/{VALUE}",
    "explorerAddr": "https://tonscan.org/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "TON"
  },
  {
    "key": "dot",
    "label": "DOT",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in Polkadot Explorer",
    "explorerTx": "https://polkascan.io/{TYPE}/{VALUE}",
    "explorerAddr": "https://polkascan.io/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "Polkadot"
  },
  {
    "key": "ksm",
    "label": "KSM",
    "baseUrl": "https://common.dev1.glprotocol.com/essential-api/",
    "addressRegex": ".*",
    "txRegex": ".*",
    "family": "eth",
    "explorerTitle": "Open in Kusama Explorer",
    "explorerTx": "https://kusama.subscan.io/{TYPE}/{VALUE}",
    "explorerAddr": "https://kusama.subscan.io/{TYPE}/{VALUE}",
    "decimals": 1,
    "profilesServiceUrl": "https://common.dev1.glprotocol.com/essential-api/api-labeling",
    "isNeedTokensCall": false,
    "essential": true,
    "blockchain": "Kusama"
  }
];

export const allBlockchainCoin = {
  "key": "all",
  "label": "All",
  "family": "all",
  "blockchain": "All networks",
  "isNeedTokensCall": false, 
}

export const allTokensItem = {
  "address": "all",
  "name": "All Tokens",
  "symbol": "all",
  "decimals": 0,
  "icon": "iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHxSURBVHgB3VTRUcMwDJVckxa+2g3CBhmBbAAT0A3CCO0G7QZlAtigjOARsgH9gBKCsZDTJnYb1xyfVHe5xPbTk6zoCeC/G/qL16fxWEtTgKEpn6S8VQLiSmqxnNxtNj6WbhmbbAsCnDJJyk9JQCtZXy3x2WHxiHwNRFkvDUIljcjbIA35xceavQNYUPLrMm+DiHbf2MxD5E0alNVCP7RLnVRFkHyXclYn2w7rAhCXJWIC8d4lGccOwGGFt59C3FKXZBxL3rnwdstfnMrQd8jQO/duQI8xJyJ3zp0Tx3pcXQBp5MJ2S5gc1dae7y2pK8aSOsGuuFUXvQC2BW0rsuOc2nLZN6/fef/a0wE+w0Z+1Tl/zdty7d4491v0POxgVNw8PYwl1AVyn1Mnf1xpSJYvd4uDa89uXseiMoyFKRco5YexYmVGYjl7mfRHxZ58zcCAQlFxkLwN0pB/6jUS9rCEoMxwkLdBXBeJugiTN26ZNJWTv808QN6kQpBhpfujAk1c/iic/BFMFCtA9EcF/UH+HCKK3f2TowD8Y8uoy8F4wCgWPC7/BlH5cwm7cwMmigWPqwugYWTlrU7QKy1GnfypkgvbLSEkIanv0Vt/VNgW1DBk+VMn/13ZaO63qLWZmmzMx6DBunJggzXDN27R6zMaFT/p+ABpWC/gEAAAAABJRU5ErkJggg==",
}

